export default {
  pageTitle: 'Vessel Fabrication',
  metaDescription: 'TEF fabricates pressure vessels, reactors, storage tanks and autoclaves in stainless steel, titanium, duplex and other special materials for industrial process needs.',
  sidebar: {
    title: 'Fabrication list',
    vessel: 'Fabrication Vessel',
    heatExchanger: 'Fabrication Heat Exchanger',
    piping: 'Fabrication Piping',
    tower: 'Fabrication Tower',
    muffle: 'Fabrication Muffle',
    radiantTube: 'Fabrication Radiant Tube',
    otherEquipment: 'Fabrication Other Equipment',
  },
  fabricationOf: 'Fabrication of',
  productName: 'Vessel',
  description: 'Below is a catalog of our experience in Vessel fabrication across various materials, types, and specifications.',
};
